export default __webpack_public_path__ + "static/media/emoji-write.0c233803.svg";